<template>
    <table class="table table-bordered table-light text-center">
        <thead class="thead-dark">
        <tr>
            <th>Registrador</th>
            <th>Hex</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>R0</td>
            <td>0x0</td>
        </tr>
        <tr>
            <td>R1</td>
            <td>0x1</td>
        </tr>
        <tr>
            <td>R2</td>
            <td>0x2</td>
        </tr>
        <tr>
            <td>R3</td>
            <td>0x3</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: "RegisterTable"
    }
</script>

<style scoped>

</style>